import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

/**
 * See PHP file inc/Assets.php.
 */
var BaseOptions = /*#__PURE__*/function () {
  function BaseOptions() {
    _classCallCheck(this, BaseOptions);

    this.slug = void 0;
    this.textDomain = void 0;
    this.version = void 0;
    this.restUrl = void 0;
    this.restNamespace = void 0;
    this.restRoot = void 0;
    this.restQuery = void 0;
    this.restNonce = void 0;
    this.restRecreateNonceEndpoint = void 0;
    this.publicUrl = void 0;
    this.chunkFolder = void 0;
    this.chunks = void 0;
  }

  _createClass(BaseOptions, null, [{
    key: "slugCamelCase",
    value:
    /**
     * Convert a slug like "my-plugin" to "myPlugin". This can
     * be useful for library naming (window[""] is bad because the hyphens).
     *
     * @param slug
     * @returns
     */
    function slugCamelCase(slug) {
      return slug.replace(/-([a-z])/g, function (g) {
        return g[1].toUpperCase();
      });
    }
    /**
     * Get the slug from the current process (webpack) instead of the PHP plugin output.
     * For some cases you need to use that.
     *
     * @param env
     * @param camelCase
     */

  }, {
    key: "getPureSlug",
    value: function getPureSlug(env) {
      var camelCase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return camelCase ? BaseOptions.slugCamelCase(env.slug) : env.slug;
    }
  }]);

  return BaseOptions;
}();

export { BaseOptions };